module.exports = __webpack_public_path__ + "static/astrid-salmhofer-b1e3309ea4a792867c8bdd75e54d5fab.jpg";